import React from "react";

function UserGuide() {
  return <div>UserGuide</div>;
}

export default UserGuide;
